<template>
  <div class="second-consultation">

    <div class="head-links">
      <router-link class="back-links" to="/algorithms">Алгоритми діагностики</router-link>
      <span>/</span>
      <router-link class="now-page" to="/algorithms/abkm">ЛН чи АБКМ?</router-link>
    </div>

    <div class="content">

      <div v-if="qStage === '1'" class="q1 q-block">

        <div class="header-title">

          <p>Попередні призначення</p>
          <div @click="$router.go(-1)" class="back-arrow">
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.53564 1.52856L1.00017 5.81836" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.00016 5.81799L5.53564 10.1045" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <div class="q-text">
          <label class="btn-second-visit-first-point container">Діагностична елімінаційна дієта з виключенням
            лактози на 48 годин
            <input v-model="radioBtn" :value="1" type="radio" checked="checked" name="radio">
            <span class="checkmark"></span>
          </label>
          <label class="btn-second-visit-second-point container">Діагностична елімінаційна дієта з виключенням
            БКМ на 4–6 тижнів
            <input v-model="radioBtn" :value="2" type="radio" checked="checked" name="radio">
            <span class="checkmark"></span>
          </label>
        </div>

        <div class="next-stage-btn" @click="nextStageQ()">
          <p>Далі</p>
        </div>

      </div>

      <div v-if="qStage === '2'" class="q2 q-block">

        <div class="header-title">

          <p>ДИНАМІКА СТАНУ</p>
          <div @click="qStage= '1'" class="back-arrow">
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.53564 1.52856L1.00017 5.81836" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.00016 5.81799L5.53564 10.1045" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <div class="q-text">
          <p>Чи спостерігається у дитини <span class="bold">позитивна динаміка</span>
            на призначеній дієті?
          </p>
        </div>

        <div class="your-answer">
          <div @click="qStage = '', qResult = '1'" class="btn-second-visit-first-point-2question-yes yes">
            <div class="icon">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <circle cx="12.5005" cy="12.5" r="12" transform="rotate(-90 12.5005 12.5)"
                        stroke="#D1DDE9"/>
                <path d="M6.00049 11.811L10.5406 16.0977L19.0005 8.09766" stroke="#00ACE6"
                      stroke-width="2" stroke-miterlimit="10"/>
              </svg>

            </div>
            <p class="text">Так</p>
          </div>
          <div @click="qStage = '', qResult = '2'" class="btn-second-visit-first-point-2question-no no">
            <div class="icon">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <circle cx="12.5005" cy="12.5" r="12" transform="rotate(-90 12.5005 12.5)"
                        stroke="#D1DDE9"/>
                <path d="M8.22339 8.32031L16.7775 16.8745" stroke="#00ACE6" stroke-width="2"
                      stroke-miterlimit="10"/>
                <path d="M16.7775 8.32031L8.22339 16.8745" stroke="#00ACE6" stroke-width="2"
                      stroke-miterlimit="10"/>
              </svg>
            </div>
            <p class="text">
              Ні
            </p>
          </div>
        </div>

      </div>

      <div v-if="qStage === '3'" class="q3 q-block">

        <div class="header-title">

          <p>ДИНАМІКА СТАНУ</p>
          <div @click="qStage= '1'" class="back-arrow">
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.53564 1.52856L1.00017 5.81836" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.00016 5.81799L5.53564 10.1045" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <div class="q-text">
          <p>Чи спостерігається у дитини <span class="bold">позитивна динаміка</span>
            на призначеній дієті?
          </p>
        </div>

        <div class="your-answer">
          <div @click="qStage = '', qResult = '3'" class="btn-second-visit-second-point-2question-yes yes">
            <div class="icon">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <circle cx="12.5005" cy="12.5" r="12" transform="rotate(-90 12.5005 12.5)"
                        stroke="#D1DDE9"/>
                <path d="M6.00049 11.811L10.5406 16.0977L19.0005 8.09766" stroke="#00ACE6"
                      stroke-width="2" stroke-miterlimit="10"/>
              </svg>

            </div>
            <p class="text">Так</p>
          </div>
          <div @click="qStage = '', qResult = '4'" class="btn-second-visit-second-point-2question-no no">
            <div class="icon">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <circle cx="12.5005" cy="12.5" r="12" transform="rotate(-90 12.5005 12.5)"
                        stroke="#D1DDE9"/>
                <path d="M8.22339 8.32031L16.7775 16.8745" stroke="#00ACE6" stroke-width="2"
                      stroke-miterlimit="10"/>
                <path d="M16.7775 8.32031L8.22339 16.8745" stroke="#00ACE6" stroke-width="2"
                      stroke-miterlimit="10"/>
              </svg>
            </div>
            <p class="text">
              Ні
            </p>
          </div>
        </div>

      </div>


      <div v-if="qStage === '' && qResult === '1'" class="result result2">

        <div class="header-title">

          <p>Підсумок</p>
          <div @click="qStage= '1'" class="back-arrow">
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.53564 1.52856L1.00017 5.81836" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.00016 5.81799L5.53564 10.1045" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <div class="result-block-wrapper">

          <div class="first-consultation-block">
            <div class="color">
              <p class="text1">повторний візит</p>
              <div class="reg-text">
                <p>
                  Поліпшення стану : ТАК
                </p>
              </div>
            </div>

          </div>

          <div class="list-text">
            <p>
                            <span class="icon">
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
<path d="M13.9953 2L6.48984 9.49411L3.01326 6.02985L2.00073 5.01178" stroke="#1E3B89" stroke-width="3"
      stroke-miterlimit="10"/>
</svg>
                            </span>
              Висока ймовірність лактазної недостатності.
            </p>
            <p>
                            <span class="icon">
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
<path d="M13.9953 2L6.48984 9.49411L3.01326 6.02985L2.00073 5.01178" stroke="#1E3B89" stroke-width="3"
      stroke-miterlimit="10"/>
</svg>
                            </span>
              Продовження безлактозної чи низьколактозної дієти
            </p>
            <p>
                            <span class="icon">
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
<path d="M13.9953 2L6.48984 9.49411L3.01326 6.02985L2.00073 5.01178" stroke="#1E3B89" stroke-width="3"
      stroke-miterlimit="10"/>
</svg>
                            </span>
              Диференціальна діагностика причини лактазної недостатності

            </p>
          </div>

          <div class="pack-block">
            <p class="pack-name">Суміш суха Nutrilon Безлактозний</p>
            <img src="../../assets/img/pack/3.png" alt="">

            <div class="desk">
              <svg width="180" height="35" viewBox="0 0 180 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.8"
                      d="M0 17C0 10.3726 5.37258 5 12 5H83L90 0.5L97 5H168C174.627 5 180 10.3726 180 17V23C180 29.6274 174.627 35 168 35H12C5.37258 35 0 29.6274 0 23V17Z"
                      fill="#D5EAF8"/>
                <path
                    d="M43.793 23H43.0664V18.9102H38.1914V23H37.4707V14.4688H38.1914V18.3008H43.0664V14.4688H43.793V23ZM48.2578 23.1172C47.7188 23.1172 47.2305 22.9844 46.793 22.7188C46.3594 22.4531 46.0215 22.084 45.7793 21.6113C45.5371 21.1348 45.416 20.6016 45.416 20.0117V19.7598C45.416 19.1504 45.5332 18.6016 45.7676 18.1133C46.0059 17.625 46.3359 17.2422 46.7578 16.9648C47.1797 16.6836 47.6367 16.543 48.1289 16.543C48.8984 16.543 49.5078 16.8066 49.957 17.334C50.4102 17.8574 50.6367 18.5742 50.6367 19.4844V19.877H46.1133V20.0117C46.1133 20.7305 46.3184 21.3301 46.7285 21.8105C47.1426 22.2871 47.6621 22.5254 48.2871 22.5254C48.6621 22.5254 48.9922 22.457 49.2773 22.3203C49.5664 22.1836 49.8281 21.9648 50.0625 21.6641L50.502 21.998C49.9863 22.7441 49.2383 23.1172 48.2578 23.1172ZM48.1289 17.1406C47.6016 17.1406 47.1562 17.334 46.793 17.7207C46.4336 18.1074 46.2148 18.627 46.1367 19.2793H49.9395V19.2031C49.9199 18.5938 49.7461 18.0977 49.418 17.7148C49.0898 17.332 48.6602 17.1406 48.1289 17.1406ZM58.4297 22.0508L60.9492 16.6602H61.8164V23H61.1133V17.7969L58.6758 23H58.1777L55.6934 17.6797V23H54.9961V16.6602H55.916L58.4297 22.0508ZM64.4824 23H63.7793V16.6602H64.4824V23ZM63.6562 14.8262C63.6562 14.6934 63.6992 14.582 63.7852 14.4922C63.8711 14.3984 63.9883 14.3516 64.1367 14.3516C64.2852 14.3516 64.4023 14.3984 64.4883 14.4922C64.5781 14.582 64.623 14.6934 64.623 14.8262C64.623 14.959 64.5781 15.0703 64.4883 15.1602C64.4023 15.25 64.2852 15.2949 64.1367 15.2949C63.9883 15.2949 63.8711 15.25 63.7852 15.1602C63.6992 15.0703 63.6562 14.959 63.6562 14.8262ZM68.7363 22.5254C69.2246 22.5254 69.6328 22.3887 69.9609 22.1152C70.293 21.8379 70.4727 21.4805 70.5 21.043H71.1738C71.1543 21.4297 71.0332 21.7832 70.8105 22.1035C70.5879 22.4199 70.291 22.668 69.9199 22.8477C69.5527 23.0273 69.1582 23.1172 68.7363 23.1172C67.9043 23.1172 67.2441 22.8281 66.7559 22.25C66.2715 21.6719 66.0293 20.8945 66.0293 19.918V19.707C66.0293 19.082 66.1387 18.5293 66.3574 18.0488C66.5762 17.5684 66.8887 17.1973 67.2949 16.9355C67.7051 16.6738 68.1836 16.543 68.7305 16.543C69.4258 16.543 69.998 16.75 70.4473 17.1641C70.9004 17.5781 71.1426 18.123 71.1738 18.7988H70.5C70.4688 18.3027 70.2891 17.9023 69.9609 17.5977C69.6367 17.293 69.2266 17.1406 68.7305 17.1406C68.0977 17.1406 67.6055 17.3691 67.2539 17.8262C66.9062 18.2832 66.7324 18.9238 66.7324 19.748V19.9531C66.7324 20.7617 66.9062 21.3926 67.2539 21.8457C67.6055 22.2988 68.0996 22.5254 68.7363 22.5254ZM77.1328 17.2578H74.8242V23H74.1211V17.2578H71.9004V16.6602H77.1328V17.2578ZM82.4531 16.6602H83.1562V23H82.4531V17.791L79.0312 23H78.334V16.6602H79.0312V21.875L82.4531 16.6602ZM89.5898 17.2578H87.2812V23H86.5781V17.2578H84.3574V16.6602H89.5898V17.2578ZM91.5176 18.9629H93.3457C93.8145 18.9629 94.2246 19.0488 94.5762 19.2207C94.9316 19.3887 95.1992 19.623 95.3789 19.9238C95.5625 20.2246 95.6543 20.5742 95.6543 20.9727C95.6543 21.5859 95.4434 22.0781 95.0215 22.4492C94.6035 22.8164 94.0371 23 93.3223 23H90.8203V16.6602H91.5176V18.9629ZM91.5176 19.5605V22.4082H93.334C93.8379 22.4082 94.2324 22.2812 94.5176 22.0273C94.8066 21.7734 94.9512 21.4258 94.9512 20.9844C94.9512 20.5625 94.8105 20.2227 94.5293 19.9648C94.252 19.7031 93.8711 19.5684 93.3867 19.5605H91.5176ZM104.959 16.6602V23H104.256V17.2637H101.66L101.549 19.6367C101.502 20.5156 101.414 21.1875 101.285 21.6523C101.156 22.1133 100.965 22.4531 100.711 22.6719C100.457 22.8906 100.119 23 99.6973 23H99.4277V22.3789L99.6445 22.3672C100.047 22.3594 100.336 22.1641 100.512 21.7812C100.688 21.3984 100.803 20.7148 100.857 19.7305L100.986 16.6602H104.959ZM110.848 23C110.777 22.8008 110.732 22.5059 110.713 22.1152C110.467 22.4355 110.152 22.6836 109.77 22.8594C109.391 23.0312 108.988 23.1172 108.562 23.1172C107.953 23.1172 107.459 22.9473 107.08 22.6074C106.705 22.2676 106.518 21.8379 106.518 21.3184C106.518 20.7012 106.773 20.2129 107.285 19.8535C107.801 19.4941 108.518 19.3145 109.436 19.3145H110.707V18.5938C110.707 18.1406 110.566 17.7852 110.285 17.5273C110.008 17.2656 109.602 17.1348 109.066 17.1348C108.578 17.1348 108.174 17.2598 107.854 17.5098C107.533 17.7598 107.373 18.0605 107.373 18.4121L106.67 18.4062C106.67 17.9023 106.904 17.4668 107.373 17.0996C107.842 16.7285 108.418 16.543 109.102 16.543C109.809 16.543 110.365 16.7207 110.771 17.0762C111.182 17.4277 111.393 17.9199 111.404 18.5527V21.5527C111.404 22.166 111.469 22.625 111.598 22.9297V23H110.848ZM108.645 22.4961C109.113 22.4961 109.531 22.3828 109.898 22.1562C110.27 21.9297 110.539 21.627 110.707 21.248V19.8535H109.453C108.754 19.8613 108.207 19.9902 107.812 20.2402C107.418 20.4863 107.221 20.8262 107.221 21.2598C107.221 21.6152 107.352 21.9102 107.613 22.1445C107.879 22.3789 108.223 22.4961 108.645 22.4961ZM115.002 20.0938H114.029V23H113.32V16.6602H114.029V19.4727H114.99L117.316 16.6602H118.201L115.6 19.7363L118.488 23H117.562L115.002 20.0938ZM124.055 17.2578H121.746V23H121.043V17.2578H118.822V16.6602H124.055V17.2578ZM124.576 19.7363C124.576 19.127 124.693 18.5781 124.928 18.0898C125.166 17.6016 125.5 17.2227 125.93 16.9531C126.363 16.6797 126.854 16.543 127.4 16.543C128.244 16.543 128.928 16.8398 129.451 17.4336C129.975 18.0234 130.236 18.8066 130.236 19.7832V19.9297C130.236 20.543 130.117 21.0957 129.879 21.5879C129.645 22.0762 129.312 22.4531 128.883 22.7188C128.453 22.9844 127.963 23.1172 127.412 23.1172C126.572 23.1172 125.889 22.8223 125.361 22.2324C124.838 21.6387 124.576 20.8535 124.576 19.877V19.7363ZM125.279 19.9297C125.279 20.6875 125.475 21.3105 125.865 21.7988C126.26 22.2832 126.775 22.5254 127.412 22.5254C128.045 22.5254 128.557 22.2832 128.947 21.7988C129.342 21.3105 129.539 20.668 129.539 19.8711V19.7363C129.539 19.252 129.449 18.8086 129.27 18.4062C129.09 18.0039 128.838 17.6934 128.514 17.4746C128.189 17.252 127.818 17.1406 127.4 17.1406C126.775 17.1406 126.266 17.3867 125.871 17.8789C125.477 18.3672 125.279 19.0078 125.279 19.8008V19.9297ZM135.404 18.3359C135.404 17.9531 135.262 17.6582 134.977 17.4512C134.691 17.2441 134.299 17.1406 133.799 17.1406C133.346 17.1406 132.957 17.2578 132.633 17.4922C132.312 17.7227 132.152 18.0156 132.152 18.3711H131.455C131.455 17.8438 131.68 17.4082 132.129 17.0645C132.582 16.7207 133.139 16.5488 133.799 16.5488C134.525 16.5488 135.092 16.7051 135.498 17.0176C135.904 17.3301 136.107 17.7734 136.107 18.3477C136.107 18.6523 136.014 18.9277 135.826 19.1738C135.639 19.4199 135.365 19.6113 135.006 19.748C135.818 19.9707 136.225 20.4746 136.225 21.2598C136.225 21.8301 136.004 22.2812 135.562 22.6133C135.121 22.9453 134.535 23.1113 133.805 23.1113C133.098 23.1113 132.512 22.9336 132.047 22.5781C131.582 22.2227 131.35 21.7578 131.35 21.1836H132.053C132.053 21.5664 132.221 21.8867 132.557 22.1445C132.896 22.3984 133.312 22.5254 133.805 22.5254C134.34 22.5254 134.758 22.4141 135.059 22.1914C135.363 21.9648 135.516 21.6582 135.516 21.2715C135.516 20.8457 135.377 20.5391 135.1 20.3516C134.822 20.1641 134.398 20.0703 133.828 20.0703H132.861V19.4609H133.945C134.918 19.4375 135.404 19.0625 135.404 18.3359ZM141.938 16.6602H142.641V23H141.938V17.791L138.516 23H137.818V16.6602H138.516V21.875L141.938 16.6602Z"
                    fill="#1E3B89"/>
              </svg>


            </div>

            <div @click="goToNextStage(2)"
                 class="btn-second-visit-first-point-2question-yes-calc-nonlactose calc-btn">
              <p>розрахувати добову норму</p>
            </div>
          </div>

          <div class="pack-block">
            <p class="pack-name">Суміш суха Nutrilon Комфорт 1</p>
            <img src="../../assets/img/pack/1.png" alt="">

            <div class="desk">
              <svg width="180" height="35" viewBox="0 0 180 35" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.8"
                      d="M0 17C0 10.3726 5.37258 5 12 5H83L90 0.5L97 5H168C174.627 5 180 10.3726 180 17V23C180 29.6274 174.627 35 168 35H12C5.37258 35 0 29.6274 0 23V17Z"
                      fill="#D5EAF8"/>
                <path
                    d="M36.1582 23H30.8145V22.4609L33.7383 19.1445C34.2227 18.5859 34.5586 18.125 34.7461 17.7617C34.9336 17.3984 35.0273 17.0449 35.0273 16.7012C35.0273 16.1621 34.8691 15.7363 34.5527 15.4238C34.2363 15.1074 33.8008 14.9492 33.2461 14.9492C32.6719 14.9492 32.207 15.1328 31.8516 15.5C31.5 15.8672 31.3242 16.3438 31.3242 16.9297H30.627C30.627 16.4492 30.7344 16.0117 30.9492 15.6172C31.168 15.2227 31.4766 14.9141 31.875 14.6914C32.2773 14.4648 32.7344 14.3516 33.2461 14.3516C34.0273 14.3516 34.6367 14.5566 35.0742 14.9668C35.5156 15.377 35.7363 15.9355 35.7363 16.6426C35.7363 17.041 35.6113 17.4766 35.3613 17.9492C35.1152 18.4219 34.6797 19.0117 34.0547 19.7188L31.6758 22.4082H36.1582V23ZM37.4355 24.5938L37.0195 24.2891C37.375 23.8125 37.5586 23.3184 37.5703 22.8066V21.8984H38.2559V22.6309C38.2559 23.4434 37.9824 24.0977 37.4355 24.5938ZM45.0234 14.873L41.3789 23H40.6465L44.2676 15.0664H39.416V14.4688H45.0234V14.873ZM53.4023 17.2637H50.1973V23H49.4941V16.6602H53.4023V17.2637ZM62.3086 16.6602V23H61.6055V17.2637H59.0098L58.8984 19.6367C58.8516 20.5156 58.7637 21.1875 58.6348 21.6523C58.5059 22.1133 58.3145 22.4531 58.0605 22.6719C57.8066 22.8906 57.4688 23 57.0469 23H56.7773V22.3789L56.9941 22.3672C57.3965 22.3594 57.6855 22.1641 57.8613 21.7812C58.0371 21.3984 58.1523 20.7148 58.207 19.7305L58.3359 16.6602H62.3086ZM68.1973 23C68.127 22.8008 68.082 22.5059 68.0625 22.1152C67.8164 22.4355 67.502 22.6836 67.1191 22.8594C66.7402 23.0312 66.3379 23.1172 65.9121 23.1172C65.3027 23.1172 64.8086 22.9473 64.4297 22.6074C64.0547 22.2676 63.8672 21.8379 63.8672 21.3184C63.8672 20.7012 64.123 20.2129 64.6348 19.8535C65.1504 19.4941 65.8672 19.3145 66.7852 19.3145H68.0566V18.5938C68.0566 18.1406 67.916 17.7852 67.6348 17.5273C67.3574 17.2656 66.9512 17.1348 66.416 17.1348C65.9277 17.1348 65.5234 17.2598 65.2031 17.5098C64.8828 17.7598 64.7227 18.0605 64.7227 18.4121L64.0195 18.4062C64.0195 17.9023 64.2539 17.4668 64.7227 17.0996C65.1914 16.7285 65.7676 16.543 66.4512 16.543C67.1582 16.543 67.7148 16.7207 68.1211 17.0762C68.5312 17.4277 68.7422 17.9199 68.7539 18.5527V21.5527C68.7539 22.166 68.8184 22.625 68.9473 22.9297V23H68.1973ZM65.9941 22.4961C66.4629 22.4961 66.8809 22.3828 67.248 22.1562C67.6191 21.9297 67.8887 21.627 68.0566 21.248V19.8535H66.8027C66.1035 19.8613 65.5566 19.9902 65.1621 20.2402C64.7676 20.4863 64.5703 20.8262 64.5703 21.2598C64.5703 21.6152 64.7012 21.9102 64.9629 22.1445C65.2285 22.3789 65.5723 22.4961 65.9941 22.4961ZM72.3516 20.0938H71.3789V23H70.6699V16.6602H71.3789V19.4727H72.3398L74.666 16.6602H75.5508L72.9492 19.7363L75.8379 23H74.9121L72.3516 20.0938ZM81.4043 17.2578H79.0957V23H78.3926V17.2578H76.1719V16.6602H81.4043V17.2578ZM81.9258 19.7363C81.9258 19.127 82.043 18.5781 82.2773 18.0898C82.5156 17.6016 82.8496 17.2227 83.2793 16.9531C83.7129 16.6797 84.2031 16.543 84.75 16.543C85.5938 16.543 86.2773 16.8398 86.8008 17.4336C87.3242 18.0234 87.5859 18.8066 87.5859 19.7832V19.9297C87.5859 20.543 87.4668 21.0957 87.2285 21.5879C86.9941 22.0762 86.6621 22.4531 86.2324 22.7188C85.8027 22.9844 85.3125 23.1172 84.7617 23.1172C83.9219 23.1172 83.2383 22.8223 82.7109 22.2324C82.1875 21.6387 81.9258 20.8535 81.9258 19.877V19.7363ZM82.6289 19.9297C82.6289 20.6875 82.8242 21.3105 83.2148 21.7988C83.6094 22.2832 84.125 22.5254 84.7617 22.5254C85.3945 22.5254 85.9062 22.2832 86.2969 21.7988C86.6914 21.3105 86.8887 20.668 86.8887 19.8711V19.7363C86.8887 19.252 86.7988 18.8086 86.6191 18.4062C86.4395 18.0039 86.1875 17.6934 85.8633 17.4746C85.5391 17.252 85.168 17.1406 84.75 17.1406C84.125 17.1406 83.6152 17.3867 83.2207 17.8789C82.8262 18.3672 82.6289 19.0078 82.6289 19.8008V19.9297ZM92.7539 18.3359C92.7539 17.9531 92.6113 17.6582 92.3262 17.4512C92.041 17.2441 91.6484 17.1406 91.1484 17.1406C90.6953 17.1406 90.3066 17.2578 89.9824 17.4922C89.6621 17.7227 89.502 18.0156 89.502 18.3711H88.8047C88.8047 17.8438 89.0293 17.4082 89.4785 17.0645C89.9316 16.7207 90.4883 16.5488 91.1484 16.5488C91.875 16.5488 92.4414 16.7051 92.8477 17.0176C93.2539 17.3301 93.457 17.7734 93.457 18.3477C93.457 18.6523 93.3633 18.9277 93.1758 19.1738C92.9883 19.4199 92.7148 19.6113 92.3555 19.748C93.168 19.9707 93.5742 20.4746 93.5742 21.2598C93.5742 21.8301 93.3535 22.2812 92.9121 22.6133C92.4707 22.9453 91.8848 23.1113 91.1543 23.1113C90.4473 23.1113 89.8613 22.9336 89.3965 22.5781C88.9316 22.2227 88.6992 21.7578 88.6992 21.1836H89.4023C89.4023 21.5664 89.5703 21.8867 89.9062 22.1445C90.2461 22.3984 90.6621 22.5254 91.1543 22.5254C91.6895 22.5254 92.1074 22.4141 92.4082 22.1914C92.7129 21.9648 92.8652 21.6582 92.8652 21.2715C92.8652 20.8457 92.7266 20.5391 92.4492 20.3516C92.1719 20.1641 91.748 20.0703 91.1777 20.0703H90.2109V19.4609H91.2949C92.2676 19.4375 92.7539 19.0625 92.7539 18.3359ZM99.2871 16.6602H99.9902V23H99.2871V17.791L95.8652 23H95.168V16.6602H95.8652V21.875L99.2871 16.6602ZM104.689 23.7324H104.051L107.613 14.4688H108.246L104.689 23.7324ZM115.629 23H114.926V15.3125L112.605 16.1738V15.5176L115.512 14.4395H115.629V23ZM124.166 19.4434C124.166 20.6465 123.945 21.5605 123.504 22.1855C123.062 22.8066 122.412 23.1172 121.553 23.1172C120.709 23.1172 120.062 22.8125 119.613 22.2031C119.164 21.5898 118.934 20.6992 118.922 19.5312V18.002C118.922 16.8027 119.145 15.8945 119.59 15.2773C120.035 14.6602 120.686 14.3516 121.541 14.3516C122.385 14.3516 123.029 14.6504 123.475 15.248C123.92 15.8418 124.15 16.7188 124.166 17.8789V19.4434ZM123.463 17.9141C123.463 16.9375 123.303 16.1992 122.982 15.6992C122.666 15.1992 122.186 14.9492 121.541 14.9492C120.908 14.9492 120.432 15.1934 120.111 15.6816C119.791 16.1699 119.627 16.8906 119.619 17.8438V19.5195C119.619 20.4922 119.783 21.2363 120.111 21.752C120.443 22.2676 120.924 22.5254 121.553 22.5254C122.178 22.5254 122.65 22.2734 122.971 21.7695C123.295 21.2656 123.459 20.5273 123.463 19.5547V17.9141ZM130.822 19.4434C130.822 20.6465 130.602 21.5605 130.16 22.1855C129.719 22.8066 129.068 23.1172 128.209 23.1172C127.365 23.1172 126.719 22.8125 126.27 22.2031C125.82 21.5898 125.59 20.6992 125.578 19.5312V18.002C125.578 16.8027 125.801 15.8945 126.246 15.2773C126.691 14.6602 127.342 14.3516 128.197 14.3516C129.041 14.3516 129.686 14.6504 130.131 15.248C130.576 15.8418 130.807 16.7188 130.822 17.8789V19.4434ZM130.119 17.9141C130.119 16.9375 129.959 16.1992 129.639 15.6992C129.322 15.1992 128.842 14.9492 128.197 14.9492C127.564 14.9492 127.088 15.1934 126.768 15.6816C126.447 16.1699 126.283 16.8906 126.275 17.8438V19.5195C126.275 20.4922 126.439 21.2363 126.768 21.752C127.1 22.2676 127.58 22.5254 128.209 22.5254C128.834 22.5254 129.307 22.2734 129.627 21.7695C129.951 21.2656 130.115 20.5273 130.119 19.5547V17.9141ZM138.873 22.0508L141.393 16.6602H142.26V23H141.557V17.7969L139.119 23H138.621L136.137 17.6797V23H135.439V16.6602H136.359L138.873 22.0508ZM149.016 16.6602V23H148.312V17.2637H145.717L145.605 19.6367C145.559 20.5156 145.471 21.1875 145.342 21.6523C145.213 22.1133 145.021 22.4531 144.768 22.6719C144.514 22.8906 144.176 23 143.754 23H143.484V22.3789L143.701 22.3672C144.104 22.3594 144.393 22.1641 144.568 21.7812C144.744 21.3984 144.859 20.7148 144.914 19.7305L145.043 16.6602H149.016Z"
                    fill="#1E3B89"/>
              </svg>

            </div>

            <div @click="goToNextStage(0)"
                 class="btn-second-visit-first-point-2question-yes-calc-nutrilon-comfort calc-btn">
              <p>розрахувати добову норму</p>
            </div>
          </div>

          <div class="pack-block">
            <p class="pack-name">Суміш суха Nutrilon Кисломолочний</p>
            <img src="../../assets/img/pack/6.png" alt="">

            <div class="desk">
              <svg width="220" height="45" viewBox="0 0 220 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.8"
                      d="M0 24.7453C0 13.559 9.06833 4.49064 20.2547 4.49064H103L110 0L117 4.49064H199.745C210.932 4.49064 220 13.559 220 24.7453C220 35.9317 210.932 45 199.745 45H20.2547C9.06834 45 0 35.9317 0 24.7453Z"
                      fill="#D5EAF8"/>
                <path
                    d="M25.3945 19.252H26.7246V19.8438H25.3945V22H24.6914V19.8438H20.6777V19.4453L24.627 13.4688H25.3945V19.252ZM21.5391 19.252H24.6914V14.377L24.3809 14.916L21.5391 19.252ZM27.709 23.5938L27.293 23.2891C27.6484 22.8125 27.832 22.3184 27.8438 21.8066V20.8984H28.5293V21.6309C28.5293 22.4434 28.2559 23.0977 27.709 23.5938ZM31.5996 17.3535H32.3262C32.7285 17.3535 33.0801 17.2832 33.3809 17.1426C33.6816 16.998 33.9102 16.8027 34.0664 16.5566C34.2266 16.3066 34.3066 16.0195 34.3066 15.6953C34.3066 15.1484 34.1523 14.7207 33.8438 14.4121C33.5352 14.1035 33.0918 13.9492 32.5137 13.9492C31.9668 13.9492 31.5176 14.1113 31.166 14.4355C30.8184 14.7559 30.6445 15.1797 30.6445 15.707H29.9414C29.9414 15.2656 30.0527 14.8633 30.2754 14.5C30.498 14.1328 30.8066 13.8496 31.2012 13.6504C31.5957 13.4512 32.0332 13.3516 32.5137 13.3516C33.2871 13.3516 33.8965 13.5625 34.3418 13.9844C34.7871 14.4062 35.0098 14.9844 35.0098 15.7188C35.0098 16.1289 34.8789 16.5078 34.6172 16.8555C34.3594 17.1992 34.0039 17.457 33.5508 17.6289C34.082 17.7773 34.4844 18.0332 34.7578 18.3965C35.0312 18.7559 35.168 19.1855 35.168 19.6855C35.168 20.416 34.9297 21.0039 34.4531 21.4492C33.9766 21.8945 33.3398 22.1172 32.543 22.1172C32.0352 22.1172 31.5684 22.0156 31.1426 21.8125C30.7207 21.6094 30.3926 21.3262 30.1582 20.9629C29.9277 20.5957 29.8125 20.1699 29.8125 19.6855H30.5156C30.5156 20.2285 30.7051 20.6719 31.084 21.0156C31.4629 21.3555 31.9492 21.5254 32.543 21.5254C33.1484 21.5254 33.6191 21.3711 33.9551 21.0625C34.2949 20.75 34.4648 20.2988 34.4648 19.709C34.4648 19.1387 34.2812 18.7031 33.9141 18.4023C33.5508 18.1016 33.0137 17.9512 32.3027 17.9512H31.5996V17.3535ZM43.6758 16.2637H40.4707V22H39.7676V15.6602H43.6758V16.2637ZM52.582 15.6602V22H51.8789V16.2637H49.2832L49.1719 18.6367C49.125 19.5156 49.0371 20.1875 48.9082 20.6523C48.7793 21.1133 48.5879 21.4531 48.334 21.6719C48.0801 21.8906 47.7422 22 47.3203 22H47.0508V21.3789L47.2676 21.3672C47.6699 21.3594 47.959 21.1641 48.1348 20.7812C48.3105 20.3984 48.4258 19.7148 48.4805 18.7305L48.6094 15.6602H52.582ZM58.4707 22C58.4004 21.8008 58.3555 21.5059 58.3359 21.1152C58.0898 21.4355 57.7754 21.6836 57.3926 21.8594C57.0137 22.0312 56.6113 22.1172 56.1855 22.1172C55.5762 22.1172 55.082 21.9473 54.7031 21.6074C54.3281 21.2676 54.1406 20.8379 54.1406 20.3184C54.1406 19.7012 54.3965 19.2129 54.9082 18.8535C55.4238 18.4941 56.1406 18.3145 57.0586 18.3145H58.3301V17.5938C58.3301 17.1406 58.1895 16.7852 57.9082 16.5273C57.6309 16.2656 57.2246 16.1348 56.6895 16.1348C56.2012 16.1348 55.7969 16.2598 55.4766 16.5098C55.1562 16.7598 54.9961 17.0605 54.9961 17.4121L54.293 17.4062C54.293 16.9023 54.5273 16.4668 54.9961 16.0996C55.4648 15.7285 56.041 15.543 56.7246 15.543C57.4316 15.543 57.9883 15.7207 58.3945 16.0762C58.8047 16.4277 59.0156 16.9199 59.0273 17.5527V20.5527C59.0273 21.166 59.0918 21.625 59.2207 21.9297V22H58.4707ZM56.2676 21.4961C56.7363 21.4961 57.1543 21.3828 57.5215 21.1562C57.8926 20.9297 58.1621 20.627 58.3301 20.248V18.8535H57.0762C56.377 18.8613 55.8301 18.9902 55.4355 19.2402C55.041 19.4863 54.8438 19.8262 54.8438 20.2598C54.8438 20.6152 54.9746 20.9102 55.2363 21.1445C55.502 21.3789 55.8457 21.4961 56.2676 21.4961ZM62.625 19.0938H61.6523V22H60.9434V15.6602H61.6523V18.4727H62.6133L64.9395 15.6602H65.8242L63.2227 18.7363L66.1113 22H65.1855L62.625 19.0938ZM71.6777 16.2578H69.3691V22H68.666V16.2578H66.4453V15.6602H71.6777V16.2578ZM72.1992 18.7363C72.1992 18.127 72.3164 17.5781 72.5508 17.0898C72.7891 16.6016 73.123 16.2227 73.5527 15.9531C73.9863 15.6797 74.4766 15.543 75.0234 15.543C75.8672 15.543 76.5508 15.8398 77.0742 16.4336C77.5977 17.0234 77.8594 17.8066 77.8594 18.7832V18.9297C77.8594 19.543 77.7402 20.0957 77.502 20.5879C77.2676 21.0762 76.9355 21.4531 76.5059 21.7188C76.0762 21.9844 75.5859 22.1172 75.0352 22.1172C74.1953 22.1172 73.5117 21.8223 72.9844 21.2324C72.4609 20.6387 72.1992 19.8535 72.1992 18.877V18.7363ZM72.9023 18.9297C72.9023 19.6875 73.0977 20.3105 73.4883 20.7988C73.8828 21.2832 74.3984 21.5254 75.0352 21.5254C75.668 21.5254 76.1797 21.2832 76.5703 20.7988C76.9648 20.3105 77.1621 19.668 77.1621 18.8711V18.7363C77.1621 18.252 77.0723 17.8086 76.8926 17.4062C76.7129 17.0039 76.4609 16.6934 76.1367 16.4746C75.8125 16.252 75.4414 16.1406 75.0234 16.1406C74.3984 16.1406 73.8887 16.3867 73.4941 16.8789C73.0996 17.3672 72.9023 18.0078 72.9023 18.8008V18.9297ZM83.0273 17.3359C83.0273 16.9531 82.8848 16.6582 82.5996 16.4512C82.3145 16.2441 81.9219 16.1406 81.4219 16.1406C80.9688 16.1406 80.5801 16.2578 80.2559 16.4922C79.9355 16.7227 79.7754 17.0156 79.7754 17.3711H79.0781C79.0781 16.8438 79.3027 16.4082 79.752 16.0645C80.2051 15.7207 80.7617 15.5488 81.4219 15.5488C82.1484 15.5488 82.7148 15.7051 83.1211 16.0176C83.5273 16.3301 83.7305 16.7734 83.7305 17.3477C83.7305 17.6523 83.6367 17.9277 83.4492 18.1738C83.2617 18.4199 82.9883 18.6113 82.6289 18.748C83.4414 18.9707 83.8477 19.4746 83.8477 20.2598C83.8477 20.8301 83.627 21.2812 83.1855 21.6133C82.7441 21.9453 82.1582 22.1113 81.4277 22.1113C80.7207 22.1113 80.1348 21.9336 79.6699 21.5781C79.2051 21.2227 78.9727 20.7578 78.9727 20.1836H79.6758C79.6758 20.5664 79.8438 20.8867 80.1797 21.1445C80.5195 21.3984 80.9355 21.5254 81.4277 21.5254C81.9629 21.5254 82.3809 21.4141 82.6816 21.1914C82.9863 20.9648 83.1387 20.6582 83.1387 20.2715C83.1387 19.8457 83 19.5391 82.7227 19.3516C82.4453 19.1641 82.0215 19.0703 81.4512 19.0703H80.4844V18.4609H81.5684C82.541 18.4375 83.0273 18.0625 83.0273 17.3359ZM89.5605 15.6602H90.2637V22H89.5605V16.791L86.1387 22H85.4414V15.6602H86.1387V20.875L89.5605 15.6602ZM92.0449 22.7324H91.4062L94.9688 13.4688H95.6016L92.0449 22.7324ZM61.6406 37H60.9375V29.3125L58.6172 30.1738V29.5176L61.5234 28.4395H61.6406V37ZM70.1777 33.4434C70.1777 34.6465 69.957 35.5605 69.5156 36.1855C69.0742 36.8066 68.4238 37.1172 67.5645 37.1172C66.7207 37.1172 66.0742 36.8125 65.625 36.2031C65.1758 35.5898 64.9453 34.6992 64.9336 33.5312V32.002C64.9336 30.8027 65.1562 29.8945 65.6016 29.2773C66.0469 28.6602 66.6973 28.3516 67.5527 28.3516C68.3965 28.3516 69.041 28.6504 69.4863 29.248C69.9316 29.8418 70.1621 30.7188 70.1777 31.8789V33.4434ZM69.4746 31.9141C69.4746 30.9375 69.3145 30.1992 68.9941 29.6992C68.6777 29.1992 68.1973 28.9492 67.5527 28.9492C66.9199 28.9492 66.4434 29.1934 66.123 29.6816C65.8027 30.1699 65.6387 30.8906 65.6309 31.8438V33.5195C65.6309 34.4922 65.7949 35.2363 66.123 35.752C66.4551 36.2676 66.9355 36.5254 67.5645 36.5254C68.1895 36.5254 68.6621 36.2734 68.9824 35.7695C69.3066 35.2656 69.4707 34.5273 69.4746 33.5547V31.9141ZM76.834 33.4434C76.834 34.6465 76.6133 35.5605 76.1719 36.1855C75.7305 36.8066 75.0801 37.1172 74.2207 37.1172C73.377 37.1172 72.7305 36.8125 72.2812 36.2031C71.832 35.5898 71.6016 34.6992 71.5898 33.5312V32.002C71.5898 30.8027 71.8125 29.8945 72.2578 29.2773C72.7031 28.6602 73.3535 28.3516 74.209 28.3516C75.0527 28.3516 75.6973 28.6504 76.1426 29.248C76.5879 29.8418 76.8184 30.7188 76.834 31.8789V33.4434ZM76.1309 31.9141C76.1309 30.9375 75.9707 30.1992 75.6504 29.6992C75.334 29.1992 74.8535 28.9492 74.209 28.9492C73.5762 28.9492 73.0996 29.1934 72.7793 29.6816C72.459 30.1699 72.2949 30.8906 72.2871 31.8438V33.5195C72.2871 34.4922 72.4512 35.2363 72.7793 35.752C73.1113 36.2676 73.5918 36.5254 74.2207 36.5254C74.8457 36.5254 75.3184 36.2734 75.6387 35.7695C75.9629 35.2656 76.127 34.5273 76.1309 33.5547V31.9141ZM84.8848 36.0508L87.4043 30.6602H88.2715V37H87.5684V31.7969L85.1309 37H84.6328L82.1484 31.6797V37H81.4512V30.6602H82.3711L84.8848 36.0508ZM95.0273 30.6602V37H94.3242V31.2637H91.7285L91.6172 33.6367C91.5703 34.5156 91.4824 35.1875 91.3535 35.6523C91.2246 36.1133 91.0332 36.4531 90.7793 36.6719C90.5254 36.8906 90.1875 37 89.7656 37H89.4961V36.3789L89.7129 36.3672C90.1152 36.3594 90.4043 36.1641 90.5801 35.7812C90.7559 35.3984 90.8711 34.7148 90.9258 33.7305L91.0547 30.6602H95.0273Z"
                    fill="#1E3B89"/>
                <path
                    d="M111.305 23.2578H113.9V23.9141H111.305V26.7383H110.596V23.9141H108.053V23.2578H110.596V20.5273H111.305V23.2578Z"
                    fill="#1E3B89"/>
                <path
                    d="M132.012 23.8945C132.012 24.8828 131.793 25.668 131.355 26.25C130.918 26.8281 130.332 27.1172 129.598 27.1172C128.73 27.1172 128.066 26.8125 127.605 26.2031V29.4375H126.908V20.6602H127.559L127.594 21.5566C128.051 20.8809 128.713 20.543 129.58 20.543C130.338 20.543 130.932 20.8301 131.361 21.4043C131.795 21.9785 132.012 22.7754 132.012 23.7949V23.8945ZM131.309 23.7715C131.309 22.9629 131.143 22.3242 130.811 21.8555C130.479 21.3867 130.016 21.1523 129.422 21.1523C128.992 21.1523 128.623 21.2559 128.314 21.4629C128.006 21.6699 127.77 21.9707 127.605 22.3652V25.4062C127.773 25.7695 128.014 26.0469 128.326 26.2383C128.639 26.4297 129.008 26.5254 129.434 26.5254C130.023 26.5254 130.482 26.291 130.811 25.8223C131.143 25.3496 131.309 24.666 131.309 23.7715ZM140.057 27H139.33V22.9102H134.455V27H133.734V18.4688H134.455V22.3008H139.33V18.4688H140.057V27ZM149.83 22.1426H144.943V21.5215H149.83V22.1426ZM149.83 24.5508H144.943V23.9297H149.83V24.5508ZM154.91 22.6289L155.326 18.4688H159.592V19.1191H155.93L155.631 22.002C156.088 21.6895 156.623 21.5332 157.236 21.5332C158.006 21.5332 158.619 21.7832 159.076 22.2832C159.533 22.7832 159.762 23.4492 159.762 24.2812C159.762 25.1797 159.539 25.877 159.094 26.373C158.648 26.8691 158.021 27.1172 157.213 27.1172C156.471 27.1172 155.869 26.9102 155.408 26.4961C154.947 26.082 154.684 25.502 154.617 24.7559H155.291C155.357 25.3379 155.555 25.7793 155.883 26.0801C156.211 26.377 156.654 26.5254 157.213 26.5254C157.822 26.5254 158.281 26.332 158.59 25.9453C158.902 25.5586 159.059 25.0078 159.059 24.293C159.059 23.668 158.885 23.1582 158.537 22.7637C158.189 22.3691 157.715 22.1719 157.113 22.1719C156.781 22.1719 156.492 22.2148 156.246 22.3008C156 22.3828 155.74 22.5449 155.467 22.7871L154.91 22.6289ZM161.057 28.5938L160.641 28.2891C160.996 27.8125 161.18 27.3184 161.191 26.8066V25.8984H161.877V26.6309C161.877 27.4434 161.604 28.0977 161.057 28.5938ZM168.645 18.873L165 27H164.268L167.889 19.0664H163.037V18.4688H168.645V18.873ZM172.336 23.5312H169.529V22.9395H172.336V23.5312ZM177.615 18.4043V19.0195H177.533C176.514 19.0195 175.711 19.3203 175.125 19.9219C174.539 20.5195 174.215 21.3516 174.152 22.418C174.387 22.0938 174.686 21.8438 175.049 21.668C175.412 21.4883 175.818 21.3984 176.268 21.3984C177.018 21.3984 177.613 21.6582 178.055 22.1777C178.5 22.6934 178.723 23.3691 178.723 24.2051C178.723 24.7598 178.619 25.2598 178.412 25.7051C178.205 26.1504 177.908 26.498 177.521 26.748C177.135 26.9941 176.693 27.1172 176.197 27.1172C175.381 27.1172 174.717 26.8223 174.205 26.2324C173.693 25.6387 173.438 24.873 173.438 23.9355V23.2324C173.438 21.7051 173.785 20.5234 174.48 19.6875C175.176 18.8477 176.162 18.4199 177.439 18.4043H177.615ZM176.156 22.002C175.711 22.002 175.295 22.1348 174.908 22.4004C174.525 22.6621 174.27 22.9961 174.141 23.4023V24C174.141 24.7422 174.33 25.3477 174.709 25.8164C175.092 26.2852 175.588 26.5195 176.197 26.5195C176.744 26.5195 177.186 26.3027 177.521 25.8691C177.861 25.4355 178.031 24.8887 178.031 24.2285C178.031 23.5566 177.861 23.0176 177.521 22.6113C177.186 22.2051 176.73 22.002 176.156 22.002ZM180.1 28.5938L179.684 28.2891C180.039 27.8125 180.223 27.3184 180.234 26.8066V25.8984H180.92V26.6309C180.92 27.4434 180.646 28.0977 180.1 28.5938ZM185.695 27H184.992V19.3125L182.672 20.1738V19.5176L185.578 18.4395H185.695V27Z"
                    fill="#1E3B89"/>
              </svg>

            </div>

            <div @click="goToNextStage(5)"
                 class="btn-second-visit-first-point-2question-yes-calc-nutrilon-dairy calc-btn">
              <p>розрахувати добову норму</p>
            </div>
          </div>


        </div>

        <div @click="goToMenu()" class="to-menu-btn">
          <p>В меню</p>
        </div>
      </div>

      <div v-if=" qStage === '' && qResult === '2'" class="result result2">

        <div class="header-title">

          <p>Підсумок</p>
          <div @click="qStage= '1'" class="back-arrow">
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.53564 1.52856L1.00017 5.81836" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.00016 5.81799L5.53564 10.1045" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <div class="result-block-wrapper">

          <div class="first-consultation-block">
            <div class="color">
              <p class="text1">повторний візит</p>
              <div class="reg-text">
                <p>
                  Поліпшення стану : НІ
                </p>
              </div>
            </div>

          </div>

          <div class="list-text">
            <p>
                            <span class="icon">
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
<path d="M13.9953 2L6.48984 9.49411L3.01326 6.02985L2.00073 5.01178" stroke="#1E3B89" stroke-width="3"
      stroke-miterlimit="10"/>
</svg>
                            </span>
              Висока ймовірність алергії на білок коров’ячого молока
            </p>
            <p>
                            <span class="icon">
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
<path d="M13.9953 2L6.48984 9.49411L3.01326 6.02985L2.00073 5.01178" stroke="#1E3B89" stroke-width="3"
      stroke-miterlimit="10"/>
</svg>
                            </span>
              Діагностична елімінаційна дієта з виключенням білка коров’ячого молока на 4-6 тижнів

            </p>
          </div>

          <div class="pack-block">
            <p class="pack-name">Суміш суха Nutrilon Пепті</p>
            <img src="../../assets/img/pack/2.png" alt="">

            <div class="desk">
              <svg width="180" height="35" viewBox="0 0 180 35" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.8"
                      d="M-0.000488281 17C-0.000488281 10.3726 5.37209 5 11.9995 5H82.9995L89.9995 0.5L96.9995 5H168C174.627 5 180 10.3726 180 17V23C180 29.6274 174.627 35 168 35H11.9995C5.37209 35 -0.000488281 29.6274 -0.000488281 23V17Z"
                      fill="#D5EAF8"/>
                <path
                    d="M31.3296 15.084H26.9058V23H26.1851V14.4688H31.3296V15.084ZM36.0933 16.6602V23H35.3901V17.2637H32.7944L32.6831 19.6367C32.6362 20.5156 32.5483 21.1875 32.4194 21.6523C32.2905 22.1133 32.0991 22.4531 31.8452 22.6719C31.5913 22.8906 31.2534 23 30.8315 23H30.562V22.3789L30.7788 22.3672C31.1812 22.3594 31.4702 22.1641 31.646 21.7812C31.8218 21.3984 31.937 20.7148 31.9917 19.7305L32.1206 16.6602H36.0933ZM42.146 16.6602H42.8491V23H42.146V17.791L38.7241 23H38.0269V16.6602H38.7241V21.875L42.146 16.6602ZM47.2847 17.082C48.0894 17.082 48.7417 17.3457 49.2417 17.873C49.7417 18.3965 49.9917 19.0918 49.9917 19.959V20.1113C49.9917 20.6855 49.8765 21.2031 49.646 21.6641C49.4194 22.1211 49.0913 22.4785 48.6616 22.7363C48.2358 22.9902 47.7456 23.1172 47.1909 23.1172C46.355 23.1172 45.6772 22.8398 45.1577 22.2852C44.6421 21.7266 44.3843 20.9824 44.3843 20.0527V19.4902C44.3843 18.1777 44.6343 17.1289 45.1343 16.3438C45.6343 15.5586 46.3452 15.0898 47.2671 14.9375C47.8491 14.8438 48.2573 14.7168 48.4917 14.5566C48.73 14.3965 48.8491 14.1777 48.8491 13.9004H49.4526C49.4526 14.2285 49.3843 14.5 49.2476 14.7148C49.1108 14.9297 48.9058 15.1035 48.6323 15.2363C48.3589 15.3652 47.9409 15.4746 47.3784 15.5645C46.7339 15.666 46.2144 15.9414 45.8198 16.3906C45.4292 16.8359 45.1753 17.4336 45.0581 18.1836C45.3081 17.8555 45.6206 17.5898 45.9956 17.3867C46.3745 17.1836 46.8042 17.082 47.2847 17.082ZM45.0874 19.9648V20.1113C45.0874 20.8262 45.2808 21.4082 45.6675 21.8574C46.0542 22.3027 46.562 22.5254 47.1909 22.5254C47.8237 22.5254 48.3315 22.3008 48.7144 21.8516C49.0972 21.3984 49.2886 20.8047 49.2886 20.0703V19.918C49.2886 19.2578 49.0933 18.7188 48.7026 18.3008C48.3159 17.8828 47.8081 17.6738 47.1792 17.6738C46.5503 17.6738 46.0444 17.8867 45.6616 18.3125C45.2788 18.7344 45.0874 19.2852 45.0874 19.9648ZM50.9526 19.7363C50.9526 19.127 51.0698 18.5781 51.3042 18.0898C51.5425 17.6016 51.8765 17.2227 52.3062 16.9531C52.7397 16.6797 53.23 16.543 53.7769 16.543C54.6206 16.543 55.3042 16.8398 55.8276 17.4336C56.3511 18.0234 56.6128 18.8066 56.6128 19.7832V19.9297C56.6128 20.543 56.4937 21.0957 56.2554 21.5879C56.021 22.0762 55.689 22.4531 55.2593 22.7188C54.8296 22.9844 54.3394 23.1172 53.7886 23.1172C52.9487 23.1172 52.2651 22.8223 51.7378 22.2324C51.2144 21.6387 50.9526 20.8535 50.9526 19.877V19.7363ZM51.6558 19.9297C51.6558 20.6875 51.8511 21.3105 52.2417 21.7988C52.6362 22.2832 53.1519 22.5254 53.7886 22.5254C54.4214 22.5254 54.9331 22.2832 55.3237 21.7988C55.7183 21.3105 55.9155 20.668 55.9155 19.8711V19.7363C55.9155 19.252 55.8257 18.8086 55.646 18.4062C55.4663 18.0039 55.2144 17.6934 54.8901 17.4746C54.5659 17.252 54.1948 17.1406 53.7769 17.1406C53.1519 17.1406 52.6421 17.3867 52.2476 17.8789C51.853 18.3672 51.6558 19.0078 51.6558 19.8008V19.9297ZM59.7886 20.0938H58.8159V23H58.1069V16.6602H58.8159V19.4727H59.7769L62.103 16.6602H62.9878L60.3862 19.7363L63.2749 23H62.3491L59.7886 20.0938ZM68.4546 16.6602H69.1577V23H68.4546V17.791L65.0327 23H64.3354V16.6602H65.0327V21.875L68.4546 16.6602ZM75.2046 16.6602H75.9077V23H75.2046V17.791L71.7827 23H71.0854V16.6602H71.7827V21.875L75.2046 16.6602ZM75.1694 14.375C75.1694 14.8242 75.0151 15.1875 74.7065 15.4648C74.4019 15.7422 73.9917 15.8809 73.4761 15.8809C72.9683 15.8809 72.5581 15.7441 72.2456 15.4707C71.937 15.1934 71.7827 14.8281 71.7827 14.375H72.3804C72.3804 14.6992 72.4761 14.9473 72.6675 15.1191C72.8628 15.291 73.1323 15.377 73.4761 15.377C73.8198 15.377 74.0874 15.2871 74.2788 15.1074C74.4741 14.9277 74.5718 14.6836 74.5718 14.375H75.1694ZM84.6558 17.2637H81.4507V23H80.7476V16.6602H84.6558V17.2637ZM86.5542 23H85.8511V16.6602H86.5542V23ZM85.728 14.8262C85.728 14.6934 85.771 14.582 85.8569 14.4922C85.9429 14.3984 86.0601 14.3516 86.2085 14.3516C86.3569 14.3516 86.4741 14.3984 86.5601 14.4922C86.6499 14.582 86.6948 14.6934 86.6948 14.8262C86.6948 14.959 86.6499 15.0703 86.5601 15.1602C86.4741 15.25 86.3569 15.2949 86.2085 15.2949C86.0601 15.2949 85.9429 15.25 85.8569 15.1602C85.771 15.0703 85.728 14.959 85.728 14.8262ZM88.3179 22.4082L88.6284 22.0039C89.1206 21.3359 89.4038 20.3594 89.478 19.0742L89.5894 16.6602H93.3335V22.4082H93.9897V24.8633H93.2925V23H88.5288V24.8633H87.855L87.8608 22.4082H88.3179ZM89.1265 22.4082H92.6304V17.3164H90.2573L90.1812 18.9629C90.1108 20.4746 89.7593 21.623 89.1265 22.4082ZM100.441 19.8945C100.441 20.8828 100.222 21.668 99.7847 22.25C99.3472 22.8281 98.7612 23.1172 98.0269 23.1172C97.1597 23.1172 96.4956 22.8125 96.0347 22.2031V25.4375H95.3374V16.6602H95.9878L96.0229 17.5566C96.48 16.8809 97.1421 16.543 98.0093 16.543C98.7671 16.543 99.3608 16.8301 99.7905 17.4043C100.224 17.9785 100.441 18.7754 100.441 19.7949V19.8945ZM99.7378 19.7715C99.7378 18.9629 99.5718 18.3242 99.2397 17.8555C98.9077 17.3867 98.4448 17.1523 97.8511 17.1523C97.4214 17.1523 97.0522 17.2559 96.7437 17.4629C96.4351 17.6699 96.1987 17.9707 96.0347 18.3652V21.4062C96.2026 21.7695 96.4429 22.0469 96.7554 22.2383C97.0679 22.4297 97.437 22.5254 97.8628 22.5254C98.4526 22.5254 98.9116 22.291 99.2397 21.8223C99.5718 21.3496 99.7378 20.666 99.7378 19.7715ZM101.613 19.7363C101.613 19.127 101.73 18.5781 101.964 18.0898C102.203 17.6016 102.537 17.2227 102.966 16.9531C103.4 16.6797 103.89 16.543 104.437 16.543C105.281 16.543 105.964 16.8398 106.488 17.4336C107.011 18.0234 107.273 18.8066 107.273 19.7832V19.9297C107.273 20.543 107.154 21.0957 106.916 21.5879C106.681 22.0762 106.349 22.4531 105.919 22.7188C105.49 22.9844 105 23.1172 104.449 23.1172C103.609 23.1172 102.925 22.8223 102.398 22.2324C101.875 21.6387 101.613 20.8535 101.613 19.877V19.7363ZM102.316 19.9297C102.316 20.6875 102.511 21.3105 102.902 21.7988C103.296 22.2832 103.812 22.5254 104.449 22.5254C105.082 22.5254 105.593 22.2832 105.984 21.7988C106.378 21.3105 106.576 20.668 106.576 19.8711V19.7363C106.576 19.252 106.486 18.8086 106.306 18.4062C106.126 18.0039 105.875 17.6934 105.55 17.4746C105.226 17.252 104.855 17.1406 104.437 17.1406C103.812 17.1406 103.302 17.3867 102.908 17.8789C102.513 18.3672 102.316 19.0078 102.316 19.8008V19.9297ZM113.507 16.6602V23H112.804V17.2637H110.208L110.097 19.6367C110.05 20.5156 109.962 21.1875 109.833 21.6523C109.705 22.1133 109.513 22.4531 109.259 22.6719C109.005 22.8906 108.667 23 108.246 23H107.976V22.3789L108.193 22.3672C108.595 22.3594 108.884 22.1641 109.06 21.7812C109.236 21.3984 109.351 20.7148 109.406 19.7305L109.535 16.6602H113.507ZM116.179 23H115.476V16.6602H116.179V23ZM115.353 14.8262C115.353 14.6934 115.396 14.582 115.482 14.4922C115.568 14.3984 115.685 14.3516 115.833 14.3516C115.982 14.3516 116.099 14.3984 116.185 14.4922C116.275 14.582 116.32 14.6934 116.32 14.8262C116.32 14.959 116.275 15.0703 116.185 15.1602C116.099 15.25 115.982 15.2949 115.833 15.2949C115.685 15.2949 115.568 15.25 115.482 15.1602C115.396 15.0703 115.353 14.959 115.353 14.8262ZM121.804 18.3359C121.804 17.9531 121.662 17.6582 121.376 17.4512C121.091 17.2441 120.699 17.1406 120.199 17.1406C119.746 17.1406 119.357 17.2578 119.033 17.4922C118.712 17.7227 118.552 18.0156 118.552 18.3711H117.855C117.855 17.8438 118.08 17.4082 118.529 17.0645C118.982 16.7207 119.539 16.5488 120.199 16.5488C120.925 16.5488 121.492 16.7051 121.898 17.0176C122.304 17.3301 122.507 17.7734 122.507 18.3477C122.507 18.6523 122.414 18.9277 122.226 19.1738C122.039 19.4199 121.765 19.6113 121.406 19.748C122.218 19.9707 122.625 20.4746 122.625 21.2598C122.625 21.8301 122.404 22.2812 121.962 22.6133C121.521 22.9453 120.935 23.1113 120.205 23.1113C119.498 23.1113 118.912 22.9336 118.447 22.5781C117.982 22.2227 117.75 21.7578 117.75 21.1836H118.453C118.453 21.5664 118.621 21.8867 118.957 22.1445C119.296 22.3984 119.712 22.5254 120.205 22.5254C120.74 22.5254 121.158 22.4141 121.458 22.1914C121.763 21.9648 121.916 21.6582 121.916 21.2715C121.916 20.8457 121.777 20.5391 121.5 20.3516C121.222 20.1641 120.798 20.0703 120.228 20.0703H119.261V19.4609H120.345C121.318 19.4375 121.804 19.0625 121.804 18.3359ZM129.644 17.082C130.449 17.082 131.101 17.3457 131.601 17.873C132.101 18.3965 132.351 19.0918 132.351 19.959V20.1113C132.351 20.6855 132.236 21.2031 132.005 21.6641C131.779 22.1211 131.451 22.4785 131.021 22.7363C130.595 22.9902 130.105 23.1172 129.55 23.1172C128.714 23.1172 128.037 22.8398 127.517 22.2852C127.001 21.7266 126.744 20.9824 126.744 20.0527V19.4902C126.744 18.1777 126.994 17.1289 127.494 16.3438C127.994 15.5586 128.705 15.0898 129.626 14.9375C130.208 14.8438 130.617 14.7168 130.851 14.5566C131.089 14.3965 131.208 14.1777 131.208 13.9004H131.812C131.812 14.2285 131.744 14.5 131.607 14.7148C131.47 14.9297 131.265 15.1035 130.992 15.2363C130.718 15.3652 130.3 15.4746 129.738 15.5645C129.093 15.666 128.574 15.9414 128.179 16.3906C127.789 16.8359 127.535 17.4336 127.417 18.1836C127.667 17.8555 127.98 17.5898 128.355 17.3867C128.734 17.1836 129.164 17.082 129.644 17.082ZM127.447 19.9648V20.1113C127.447 20.8262 127.64 21.4082 128.027 21.8574C128.414 22.3027 128.921 22.5254 129.55 22.5254C130.183 22.5254 130.691 22.3008 131.074 21.8516C131.457 21.3984 131.648 20.8047 131.648 20.0703V19.918C131.648 19.2578 131.453 18.7188 131.062 18.3008C130.675 17.8828 130.167 17.6738 129.539 17.6738C128.91 17.6738 128.404 17.8867 128.021 18.3125C127.638 18.7344 127.447 19.2852 127.447 19.9648ZM134.484 23H133.781V16.6602H134.484V23ZM133.658 14.8262C133.658 14.6934 133.701 14.582 133.787 14.4922C133.873 14.3984 133.99 14.3516 134.138 14.3516C134.287 14.3516 134.404 14.3984 134.49 14.4922C134.58 14.582 134.625 14.6934 134.625 14.8262C134.625 14.959 134.58 15.0703 134.49 15.1602C134.404 15.25 134.287 15.2949 134.138 15.2949C133.99 15.2949 133.873 15.25 133.787 15.1602C133.701 15.0703 133.658 14.959 133.658 14.8262ZM141.269 16.6602V23H140.566V17.2637H137.97L137.859 19.6367C137.812 20.5156 137.724 21.1875 137.595 21.6523C137.466 22.1133 137.275 22.4531 137.021 22.6719C136.767 22.8906 136.429 23 136.007 23H135.738V22.3789L135.955 22.3672C136.357 22.3594 136.646 22.1641 136.822 21.7812C136.998 21.3984 137.113 20.7148 137.167 19.7305L137.296 16.6602H141.269ZM144.878 20.0938H143.906V23H143.197V16.6602H143.906V19.4727H144.867L147.193 16.6602H148.078L145.476 19.7363L148.365 23H147.439L144.878 20.0938ZM153.38 23C153.31 22.8008 153.265 22.5059 153.246 22.1152C153 22.4355 152.685 22.6836 152.302 22.8594C151.923 23.0312 151.521 23.1172 151.095 23.1172C150.486 23.1172 149.992 22.9473 149.613 22.6074C149.238 22.2676 149.05 21.8379 149.05 21.3184C149.05 20.7012 149.306 20.2129 149.818 19.8535C150.333 19.4941 151.05 19.3145 151.968 19.3145H153.24V18.5938C153.24 18.1406 153.099 17.7852 152.818 17.5273C152.541 17.2656 152.134 17.1348 151.599 17.1348C151.111 17.1348 150.707 17.2598 150.386 17.5098C150.066 17.7598 149.906 18.0605 149.906 18.4121L149.203 18.4062C149.203 17.9023 149.437 17.4668 149.906 17.0996C150.375 16.7285 150.951 16.543 151.634 16.543C152.341 16.543 152.898 16.7207 153.304 17.0762C153.714 17.4277 153.925 17.9199 153.937 18.5527V21.5527C153.937 22.166 154.001 22.625 154.13 22.9297V23H153.38ZM151.177 22.4961C151.646 22.4961 152.064 22.3828 152.431 22.1562C152.802 21.9297 153.072 21.627 153.24 21.248V19.8535H151.986C151.287 19.8613 150.74 19.9902 150.345 20.2402C149.951 20.4863 149.753 20.8262 149.753 21.2598C149.753 21.6152 149.884 21.9102 150.146 22.1445C150.412 22.3789 150.755 22.4961 151.177 22.4961Z"
                    fill="#1E3B89"/>
              </svg>

            </div>

            <div @click="goToNextStage(1)"
                 class="btn-second-visit-first-point-2question-no-calc-nutrilon-pepti calc-btn">
              <p>розрахувати добову норму</p>
            </div>
          </div>

        </div>

        <div @click="goToMenu()" class="to-menu-btn">
          <p>В меню</p>
        </div>
      </div>

      <div v-if="qStage === '' && qResult === '3'" class="result result2">

        <div class="header-title">

          <p>Підсумок</p>
          <div @click="qStage= '1'" class="back-arrow">
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.53564 1.52856L1.00017 5.81836" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.00016 5.81799L5.53564 10.1045" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <div class="result-block-wrapper">

          <div class="first-consultation-block">
            <div class="color">
              <p class="text1">повторний візит</p>
              <div class="reg-text">
                <p>
                  Поліпшення стану : ТАК
                </p>
              </div>
            </div>

          </div>

          <div class="list-text">
            <p>
                            <span class="icon">
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
<path d="M13.9953 2L6.48984 9.49411L3.01326 6.02985L2.00073 5.01178" stroke="#1E3B89" stroke-width="3"
      stroke-miterlimit="10"/>
</svg>
                            </span>
              Висока ймовірність алергії на білок коров’ячого молока
            </p>
            <p>
                            <span class="icon">
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
<path d="M13.9953 2L6.48984 9.49411L3.01326 6.02985L2.00073 5.01178" stroke="#1E3B89" stroke-width="3"
      stroke-miterlimit="10"/>
</svg>
                            </span>
              Продовження елімінаційної дієти з виключенням білка коров’ячого молока мінімум на 6 місяців

            </p>
          </div>

          <div class="pack-block">
            <p class="pack-name">Суміш суха Nutrilon Пепті</p>
            <img src="../../assets/img/pack/2.png" alt="">

            <div class="desk">
              <svg width="180" height="35" viewBox="0 0 180 35" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.8"
                      d="M-0.000488281 17C-0.000488281 10.3726 5.37209 5 11.9995 5H82.9995L89.9995 0.5L96.9995 5H168C174.627 5 180 10.3726 180 17V23C180 29.6274 174.627 35 168 35H11.9995C5.37209 35 -0.000488281 29.6274 -0.000488281 23V17Z"
                      fill="#D5EAF8"/>
                <path
                    d="M31.3296 15.084H26.9058V23H26.1851V14.4688H31.3296V15.084ZM36.0933 16.6602V23H35.3901V17.2637H32.7944L32.6831 19.6367C32.6362 20.5156 32.5483 21.1875 32.4194 21.6523C32.2905 22.1133 32.0991 22.4531 31.8452 22.6719C31.5913 22.8906 31.2534 23 30.8315 23H30.562V22.3789L30.7788 22.3672C31.1812 22.3594 31.4702 22.1641 31.646 21.7812C31.8218 21.3984 31.937 20.7148 31.9917 19.7305L32.1206 16.6602H36.0933ZM42.146 16.6602H42.8491V23H42.146V17.791L38.7241 23H38.0269V16.6602H38.7241V21.875L42.146 16.6602ZM47.2847 17.082C48.0894 17.082 48.7417 17.3457 49.2417 17.873C49.7417 18.3965 49.9917 19.0918 49.9917 19.959V20.1113C49.9917 20.6855 49.8765 21.2031 49.646 21.6641C49.4194 22.1211 49.0913 22.4785 48.6616 22.7363C48.2358 22.9902 47.7456 23.1172 47.1909 23.1172C46.355 23.1172 45.6772 22.8398 45.1577 22.2852C44.6421 21.7266 44.3843 20.9824 44.3843 20.0527V19.4902C44.3843 18.1777 44.6343 17.1289 45.1343 16.3438C45.6343 15.5586 46.3452 15.0898 47.2671 14.9375C47.8491 14.8438 48.2573 14.7168 48.4917 14.5566C48.73 14.3965 48.8491 14.1777 48.8491 13.9004H49.4526C49.4526 14.2285 49.3843 14.5 49.2476 14.7148C49.1108 14.9297 48.9058 15.1035 48.6323 15.2363C48.3589 15.3652 47.9409 15.4746 47.3784 15.5645C46.7339 15.666 46.2144 15.9414 45.8198 16.3906C45.4292 16.8359 45.1753 17.4336 45.0581 18.1836C45.3081 17.8555 45.6206 17.5898 45.9956 17.3867C46.3745 17.1836 46.8042 17.082 47.2847 17.082ZM45.0874 19.9648V20.1113C45.0874 20.8262 45.2808 21.4082 45.6675 21.8574C46.0542 22.3027 46.562 22.5254 47.1909 22.5254C47.8237 22.5254 48.3315 22.3008 48.7144 21.8516C49.0972 21.3984 49.2886 20.8047 49.2886 20.0703V19.918C49.2886 19.2578 49.0933 18.7188 48.7026 18.3008C48.3159 17.8828 47.8081 17.6738 47.1792 17.6738C46.5503 17.6738 46.0444 17.8867 45.6616 18.3125C45.2788 18.7344 45.0874 19.2852 45.0874 19.9648ZM50.9526 19.7363C50.9526 19.127 51.0698 18.5781 51.3042 18.0898C51.5425 17.6016 51.8765 17.2227 52.3062 16.9531C52.7397 16.6797 53.23 16.543 53.7769 16.543C54.6206 16.543 55.3042 16.8398 55.8276 17.4336C56.3511 18.0234 56.6128 18.8066 56.6128 19.7832V19.9297C56.6128 20.543 56.4937 21.0957 56.2554 21.5879C56.021 22.0762 55.689 22.4531 55.2593 22.7188C54.8296 22.9844 54.3394 23.1172 53.7886 23.1172C52.9487 23.1172 52.2651 22.8223 51.7378 22.2324C51.2144 21.6387 50.9526 20.8535 50.9526 19.877V19.7363ZM51.6558 19.9297C51.6558 20.6875 51.8511 21.3105 52.2417 21.7988C52.6362 22.2832 53.1519 22.5254 53.7886 22.5254C54.4214 22.5254 54.9331 22.2832 55.3237 21.7988C55.7183 21.3105 55.9155 20.668 55.9155 19.8711V19.7363C55.9155 19.252 55.8257 18.8086 55.646 18.4062C55.4663 18.0039 55.2144 17.6934 54.8901 17.4746C54.5659 17.252 54.1948 17.1406 53.7769 17.1406C53.1519 17.1406 52.6421 17.3867 52.2476 17.8789C51.853 18.3672 51.6558 19.0078 51.6558 19.8008V19.9297ZM59.7886 20.0938H58.8159V23H58.1069V16.6602H58.8159V19.4727H59.7769L62.103 16.6602H62.9878L60.3862 19.7363L63.2749 23H62.3491L59.7886 20.0938ZM68.4546 16.6602H69.1577V23H68.4546V17.791L65.0327 23H64.3354V16.6602H65.0327V21.875L68.4546 16.6602ZM75.2046 16.6602H75.9077V23H75.2046V17.791L71.7827 23H71.0854V16.6602H71.7827V21.875L75.2046 16.6602ZM75.1694 14.375C75.1694 14.8242 75.0151 15.1875 74.7065 15.4648C74.4019 15.7422 73.9917 15.8809 73.4761 15.8809C72.9683 15.8809 72.5581 15.7441 72.2456 15.4707C71.937 15.1934 71.7827 14.8281 71.7827 14.375H72.3804C72.3804 14.6992 72.4761 14.9473 72.6675 15.1191C72.8628 15.291 73.1323 15.377 73.4761 15.377C73.8198 15.377 74.0874 15.2871 74.2788 15.1074C74.4741 14.9277 74.5718 14.6836 74.5718 14.375H75.1694ZM84.6558 17.2637H81.4507V23H80.7476V16.6602H84.6558V17.2637ZM86.5542 23H85.8511V16.6602H86.5542V23ZM85.728 14.8262C85.728 14.6934 85.771 14.582 85.8569 14.4922C85.9429 14.3984 86.0601 14.3516 86.2085 14.3516C86.3569 14.3516 86.4741 14.3984 86.5601 14.4922C86.6499 14.582 86.6948 14.6934 86.6948 14.8262C86.6948 14.959 86.6499 15.0703 86.5601 15.1602C86.4741 15.25 86.3569 15.2949 86.2085 15.2949C86.0601 15.2949 85.9429 15.25 85.8569 15.1602C85.771 15.0703 85.728 14.959 85.728 14.8262ZM88.3179 22.4082L88.6284 22.0039C89.1206 21.3359 89.4038 20.3594 89.478 19.0742L89.5894 16.6602H93.3335V22.4082H93.9897V24.8633H93.2925V23H88.5288V24.8633H87.855L87.8608 22.4082H88.3179ZM89.1265 22.4082H92.6304V17.3164H90.2573L90.1812 18.9629C90.1108 20.4746 89.7593 21.623 89.1265 22.4082ZM100.441 19.8945C100.441 20.8828 100.222 21.668 99.7847 22.25C99.3472 22.8281 98.7612 23.1172 98.0269 23.1172C97.1597 23.1172 96.4956 22.8125 96.0347 22.2031V25.4375H95.3374V16.6602H95.9878L96.0229 17.5566C96.48 16.8809 97.1421 16.543 98.0093 16.543C98.7671 16.543 99.3608 16.8301 99.7905 17.4043C100.224 17.9785 100.441 18.7754 100.441 19.7949V19.8945ZM99.7378 19.7715C99.7378 18.9629 99.5718 18.3242 99.2397 17.8555C98.9077 17.3867 98.4448 17.1523 97.8511 17.1523C97.4214 17.1523 97.0522 17.2559 96.7437 17.4629C96.4351 17.6699 96.1987 17.9707 96.0347 18.3652V21.4062C96.2026 21.7695 96.4429 22.0469 96.7554 22.2383C97.0679 22.4297 97.437 22.5254 97.8628 22.5254C98.4526 22.5254 98.9116 22.291 99.2397 21.8223C99.5718 21.3496 99.7378 20.666 99.7378 19.7715ZM101.613 19.7363C101.613 19.127 101.73 18.5781 101.964 18.0898C102.203 17.6016 102.537 17.2227 102.966 16.9531C103.4 16.6797 103.89 16.543 104.437 16.543C105.281 16.543 105.964 16.8398 106.488 17.4336C107.011 18.0234 107.273 18.8066 107.273 19.7832V19.9297C107.273 20.543 107.154 21.0957 106.916 21.5879C106.681 22.0762 106.349 22.4531 105.919 22.7188C105.49 22.9844 105 23.1172 104.449 23.1172C103.609 23.1172 102.925 22.8223 102.398 22.2324C101.875 21.6387 101.613 20.8535 101.613 19.877V19.7363ZM102.316 19.9297C102.316 20.6875 102.511 21.3105 102.902 21.7988C103.296 22.2832 103.812 22.5254 104.449 22.5254C105.082 22.5254 105.593 22.2832 105.984 21.7988C106.378 21.3105 106.576 20.668 106.576 19.8711V19.7363C106.576 19.252 106.486 18.8086 106.306 18.4062C106.126 18.0039 105.875 17.6934 105.55 17.4746C105.226 17.252 104.855 17.1406 104.437 17.1406C103.812 17.1406 103.302 17.3867 102.908 17.8789C102.513 18.3672 102.316 19.0078 102.316 19.8008V19.9297ZM113.507 16.6602V23H112.804V17.2637H110.208L110.097 19.6367C110.05 20.5156 109.962 21.1875 109.833 21.6523C109.705 22.1133 109.513 22.4531 109.259 22.6719C109.005 22.8906 108.667 23 108.246 23H107.976V22.3789L108.193 22.3672C108.595 22.3594 108.884 22.1641 109.06 21.7812C109.236 21.3984 109.351 20.7148 109.406 19.7305L109.535 16.6602H113.507ZM116.179 23H115.476V16.6602H116.179V23ZM115.353 14.8262C115.353 14.6934 115.396 14.582 115.482 14.4922C115.568 14.3984 115.685 14.3516 115.833 14.3516C115.982 14.3516 116.099 14.3984 116.185 14.4922C116.275 14.582 116.32 14.6934 116.32 14.8262C116.32 14.959 116.275 15.0703 116.185 15.1602C116.099 15.25 115.982 15.2949 115.833 15.2949C115.685 15.2949 115.568 15.25 115.482 15.1602C115.396 15.0703 115.353 14.959 115.353 14.8262ZM121.804 18.3359C121.804 17.9531 121.662 17.6582 121.376 17.4512C121.091 17.2441 120.699 17.1406 120.199 17.1406C119.746 17.1406 119.357 17.2578 119.033 17.4922C118.712 17.7227 118.552 18.0156 118.552 18.3711H117.855C117.855 17.8438 118.08 17.4082 118.529 17.0645C118.982 16.7207 119.539 16.5488 120.199 16.5488C120.925 16.5488 121.492 16.7051 121.898 17.0176C122.304 17.3301 122.507 17.7734 122.507 18.3477C122.507 18.6523 122.414 18.9277 122.226 19.1738C122.039 19.4199 121.765 19.6113 121.406 19.748C122.218 19.9707 122.625 20.4746 122.625 21.2598C122.625 21.8301 122.404 22.2812 121.962 22.6133C121.521 22.9453 120.935 23.1113 120.205 23.1113C119.498 23.1113 118.912 22.9336 118.447 22.5781C117.982 22.2227 117.75 21.7578 117.75 21.1836H118.453C118.453 21.5664 118.621 21.8867 118.957 22.1445C119.296 22.3984 119.712 22.5254 120.205 22.5254C120.74 22.5254 121.158 22.4141 121.458 22.1914C121.763 21.9648 121.916 21.6582 121.916 21.2715C121.916 20.8457 121.777 20.5391 121.5 20.3516C121.222 20.1641 120.798 20.0703 120.228 20.0703H119.261V19.4609H120.345C121.318 19.4375 121.804 19.0625 121.804 18.3359ZM129.644 17.082C130.449 17.082 131.101 17.3457 131.601 17.873C132.101 18.3965 132.351 19.0918 132.351 19.959V20.1113C132.351 20.6855 132.236 21.2031 132.005 21.6641C131.779 22.1211 131.451 22.4785 131.021 22.7363C130.595 22.9902 130.105 23.1172 129.55 23.1172C128.714 23.1172 128.037 22.8398 127.517 22.2852C127.001 21.7266 126.744 20.9824 126.744 20.0527V19.4902C126.744 18.1777 126.994 17.1289 127.494 16.3438C127.994 15.5586 128.705 15.0898 129.626 14.9375C130.208 14.8438 130.617 14.7168 130.851 14.5566C131.089 14.3965 131.208 14.1777 131.208 13.9004H131.812C131.812 14.2285 131.744 14.5 131.607 14.7148C131.47 14.9297 131.265 15.1035 130.992 15.2363C130.718 15.3652 130.3 15.4746 129.738 15.5645C129.093 15.666 128.574 15.9414 128.179 16.3906C127.789 16.8359 127.535 17.4336 127.417 18.1836C127.667 17.8555 127.98 17.5898 128.355 17.3867C128.734 17.1836 129.164 17.082 129.644 17.082ZM127.447 19.9648V20.1113C127.447 20.8262 127.64 21.4082 128.027 21.8574C128.414 22.3027 128.921 22.5254 129.55 22.5254C130.183 22.5254 130.691 22.3008 131.074 21.8516C131.457 21.3984 131.648 20.8047 131.648 20.0703V19.918C131.648 19.2578 131.453 18.7188 131.062 18.3008C130.675 17.8828 130.167 17.6738 129.539 17.6738C128.91 17.6738 128.404 17.8867 128.021 18.3125C127.638 18.7344 127.447 19.2852 127.447 19.9648ZM134.484 23H133.781V16.6602H134.484V23ZM133.658 14.8262C133.658 14.6934 133.701 14.582 133.787 14.4922C133.873 14.3984 133.99 14.3516 134.138 14.3516C134.287 14.3516 134.404 14.3984 134.49 14.4922C134.58 14.582 134.625 14.6934 134.625 14.8262C134.625 14.959 134.58 15.0703 134.49 15.1602C134.404 15.25 134.287 15.2949 134.138 15.2949C133.99 15.2949 133.873 15.25 133.787 15.1602C133.701 15.0703 133.658 14.959 133.658 14.8262ZM141.269 16.6602V23H140.566V17.2637H137.97L137.859 19.6367C137.812 20.5156 137.724 21.1875 137.595 21.6523C137.466 22.1133 137.275 22.4531 137.021 22.6719C136.767 22.8906 136.429 23 136.007 23H135.738V22.3789L135.955 22.3672C136.357 22.3594 136.646 22.1641 136.822 21.7812C136.998 21.3984 137.113 20.7148 137.167 19.7305L137.296 16.6602H141.269ZM144.878 20.0938H143.906V23H143.197V16.6602H143.906V19.4727H144.867L147.193 16.6602H148.078L145.476 19.7363L148.365 23H147.439L144.878 20.0938ZM153.38 23C153.31 22.8008 153.265 22.5059 153.246 22.1152C153 22.4355 152.685 22.6836 152.302 22.8594C151.923 23.0312 151.521 23.1172 151.095 23.1172C150.486 23.1172 149.992 22.9473 149.613 22.6074C149.238 22.2676 149.05 21.8379 149.05 21.3184C149.05 20.7012 149.306 20.2129 149.818 19.8535C150.333 19.4941 151.05 19.3145 151.968 19.3145H153.24V18.5938C153.24 18.1406 153.099 17.7852 152.818 17.5273C152.541 17.2656 152.134 17.1348 151.599 17.1348C151.111 17.1348 150.707 17.2598 150.386 17.5098C150.066 17.7598 149.906 18.0605 149.906 18.4121L149.203 18.4062C149.203 17.9023 149.437 17.4668 149.906 17.0996C150.375 16.7285 150.951 16.543 151.634 16.543C152.341 16.543 152.898 16.7207 153.304 17.0762C153.714 17.4277 153.925 17.9199 153.937 18.5527V21.5527C153.937 22.166 154.001 22.625 154.13 22.9297V23H153.38ZM151.177 22.4961C151.646 22.4961 152.064 22.3828 152.431 22.1562C152.802 21.9297 153.072 21.627 153.24 21.248V19.8535H151.986C151.287 19.8613 150.74 19.9902 150.345 20.2402C149.951 20.4863 149.753 20.8262 149.753 21.2598C149.753 21.6152 149.884 21.9102 150.146 22.1445C150.412 22.3789 150.755 22.4961 151.177 22.4961Z"
                    fill="#1E3B89"/>
              </svg>

            </div>

            <div @click="goToNextStage(1)"
                 class="btn-second-visit-second-point-2quest-yes-calc-nutrilon-pepti calc-btn">
              <p>розрахувати добову норму</p>
            </div>
          </div>

        </div>

        <div @click="goToMenu()" class="to-menu-btn">
          <p>В меню</p>
        </div>
      </div>

      <div v-if="qStage === '' && qResult === '4'" class="result result2">

        <div class="header-title">

          <p>Підсумок</p>
          <div @click="qStage= '1'" class="back-arrow">
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.53564 1.52856L1.00017 5.81836" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.00016 5.81799L5.53564 10.1045" stroke="#00ACE6" stroke-width="2"
                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <div class="result-block-wrapper">

          <div class="first-consultation-block">
            <div class="color">
              <p class="text1">повторний візит</p>
              <div class="reg-text">
                <p>
                  Поліпшення стану : НІ
                </p>
              </div>
            </div>

          </div>

          <div class="list-text">
            <p>
                            <span class="icon">
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
<path d="M13.9953 2L6.48984 9.49411L3.01326 6.02985L2.00073 5.01178" stroke="#1E3B89" stroke-width="3"
      stroke-miterlimit="10"/>
</svg>
                            </span>
              Необхідна консультація вузьких спеціалістів
            </p>
            <p>
                            <span class="icon">
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
<path d="M13.9953 2L6.48984 9.49411L3.01326 6.02985L2.00073 5.01178" stroke="#1E3B89" stroke-width="3"
      stroke-miterlimit="10"/>
</svg>
                            </span>
              Диференціальна діагностика
            </p>
          </div>

        </div>

        <div @click="goToMenu()" class="to-menu-btn">
          <p>В меню</p>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "second-consultation",
  data: () => ({
    qStage: "1",

    radioBtn: '',
    qResult: '',
    literaturePopup: false,
  }),

  mounted() {
    this.setFooterState(false)
  },

  beforeRouteLeave(to, from, next) {
    this.setFooterState(true)
    next();
  },

  methods: {

    ...mapActions([
      'setFooterState'
    ]),

    goToNextStage(prodNumber) {
      this.$router.push({name: 'prod', params: {id: prodNumber}})
    },

    nextStageQ() {
      if (this.radioBtn === 1) {
        this.qStage = '2';

      } else if (this.radioBtn === 2) {
        this.qStage = '3';
      }
    },

    goToMenu() {
      this.$router.push("/algorithms")
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/vars";

.second-consultation {


  .head-links {
    background-color: rgba(255, 255, 255, 0.49);
    width: 100%;
    padding: 10px 15px;

    .back-links {
      color: #7392B1;
      font-family: $fontR;
      font-size: 11px;
    }

    span {
      padding: 0 5px;
      color: #7392B1;
      font-family: $fontR;
      font-size: 11px;
    }

    .now-page {
      color: #00ACE6;
      font-family: $fontSB;
      font-size: 11px;
    }
  }

  .content {
    padding: 15px;


    .q-block {

      display: flex;
      flex-direction: column;
      background: white;
      width: 100%;
      min-height: calc(100vh - 200px);

      .header-title {
        padding: 10px 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-bottom: 1px solid #DAE3ED;

        p {
          color: #9AB9D8;
          font-family: $fontB;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 2px;
        }

        .back-arrow {
          width: 30px;
          position: absolute;
          left: 15px;
          top: 8px;
          cursor: pointer;
        }


      }

      .q-text {
        margin-top: 50px;
        padding: 0 20px;

        p {
          line-height: 1.3em;
          text-align: center;
          color: #1E3B89;
          font-size: 15px;
          font-family: $fontR;

          .light {
            font-family: $fontL;
          }

          .bold {
            font-family: $fontB;
          }
        }
      }

      .your-answer {
        margin: auto 0 0 0;
        width: 100%;
        height: 25vh;
        display: flex;
        justify-content: center;
        align-self: flex-end;
        border-top: 1px solid #DAE3ED;


        .yes, .no {
          height: 100%;
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          cursor: pointer;

          svg {
            circle, path {
              transition: all 0.2s ease;
            }
          }

          &:active {
            svg {
              circle {
                fill: #00ACE6;
              }

              path {
                stroke: white;
              }
            }
          }

          .text {
            font-family: $fontR;
            font-size: 15px;
            color: #1E3B89;
            margin-top: 5px;
          }

          &.yes {
            border-right: 1px solid #DAE3ED;
            cursor: pointer;
          }
        }
      }

      &.q1 {
        .next-stage-btn {
          margin: auto auto 15px auto;
          display: flex;
          width: 130px;
          height: 40px;
          justify-content: center;
          align-self: center;
          border-radius: 4px;
          background: #00ACE6;
          cursor: pointer;

          p {
            display: flex;
            align-items: center;
            color: white;
            text-transform: uppercase;
            font-size: 15px;
            font-family: $fontB;
            letter-spacing: 2px;
          }
        }

        .q-text {
          margin: 0;
          padding: 0;

          display: flex;
          flex-direction: column;

          .container {
            padding: 15px 15px 15px 45px;
            display: block;
            position: relative;
            border-bottom: 1px solid #DAE3ED;

            margin-bottom: 12px;
            cursor: pointer;
            font-size: 15px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            color: #1E3B89;
            font-family: $fontR;
          }

          .container input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
          }

          .checkmark {
            margin: auto 0;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 15px;
            height: 17px;
            width: 17px;
            background-color: white;
            border-radius: 50%;
            border: 1px solid #00ACE6;

          }

          .checkmark:after {
            content: "";
            position: absolute;
            display: none;
          }

          .container input:checked ~ .checkmark:after {
            display: block;
          }

          .container .checkmark:after {
            left: 5px;
            top: 3px;
            width: 3px;
            height: 6px;
            border: solid #00ACE6;
            border-width: 0 2px 2px 0;
            -webkit-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
          }
        }
      }
    }

    .result {
      img {
        display: block;
        max-width: 130px;
        width: 100%;
        height: auto;
      }
    }

    .result2 {
      display: flex;
      flex-direction: column;
      background: white;
      width: 100%;
      min-height: calc(100vh - 200px);

      .header-title {
        padding: 10px 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border-bottom: 1px solid #DAE3ED;

        p {
          color: #9AB9D8;
          font-family: $fontB;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 2px;
        }

        .back-arrow {
          width: 30px;
          position: absolute;
          left: 15px;
          top: 8px;
          cursor: pointer;
        }


      }

      .to-menu-btn {
        margin: auto auto 15px auto;
        width: 142px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #00ACE6;
        border-radius: 4px;
        cursor: pointer;

        p {
          color: white;
          text-transform: uppercase;
          font-family: $fontB;
          letter-spacing: 2px;
          font-size: 15px;
        }
      }

      .result-block-wrapper {
        padding: 15px 0;

        img {
          display: block;
          max-width: 130px;
          width: 100%;
          height: auto;
        }

        .first-consultation-block {
          padding: 0 15px;

          .color {
            background: #F6F9FB;
            width: 100%;
            padding: 15px;

            .text1 {

              color: #9AB9D8;
              font-size: 12px;
              font-family: $fontB;
              text-transform: uppercase;
              letter-spacing: 2px;
            }

            .reg-text {
              margin-top: 10px;

              p {
                color: #1E3B89;
                font-size: 15px;
                font-family: $fontL;
              }
            }
          }
        }

        .list-text {
          padding: 0 15px;
          margin-top: 30px;
          margin-bottom: 30px;

          p {
            color: #1E3B89;
            font-family: $fontR;
            font-size: 15px;
            display: flex;
            flex-direction: row;
            margin-bottom: 10px;

            span {
              display: inline-block;
              margin-right: 7px;
            }
          }
        }

        .pack-block {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 30px 0;
          border-top: 1px solid #DAE3ED;
          border-bottom: 1px solid #DAE3ED;


          img {
            display: block;
            max-width: 130px;
            width: 100%;
            height: auto;
          }

          .pack-name {
            color: #1E3B89;
            font-size: 15px;
            font-family: $fontB;
            text-align: center;
            margin-bottom: 20px;
          }

          .desk {
            margin-top: 10px;
          }

          .calc-btn {
            margin-top: 30px;
            max-width: 260px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            border: 1px solid #00ACE6;
            box-sizing: border-box;
            border-radius: 4px;
            height: 40px;
            cursor: pointer;

            p {
              text-transform: uppercase;
              color: #00ACE6;
              font-size: 14px;
              font-family: $fontB;
            }
          }
        }
      }
    }
  }
}

</style>
